import { pathExists } from 'fs-extra';
import { Logger } from '../utils/logger';
import { FileWriter } from '../utils/file-writer';
import { adds, removes, replaces } from '../configs/angular-json-config';

/**
 * the angular.json upgrader class.
 */
export class AngularJsonUpgrader {
    private readonly fileName = 'angular.json';
    private filePath: string;
    private fileWriter: FileWriter;

    private messages = {
        notFound: ''
    };

    /**
     * the constructor.
     * @param filePath the file path.
     */
    constructor(filePath: string) {
        this.filePath = filePath;
        this.messages.notFound = `${this.fileName} not found at ${this.filePath}.`
    }

    /**
     * the run function to resolve the errors.
     */
    public async run(): Promise<void> {
        try {
            const exists = await pathExists(this.filePath);

            if (exists) {
                this.fileWriter = new FileWriter(this.filePath);

                this.fileWriter
                    .addContent(adds)
                    .removeContent(removes)
                    .replaceContent(replaces)
                    .writeFile();
            } else {
                Logger.log(this.messages.notFound);
            }
        } catch (error) {
            Logger.error(error);
        }
    }
}
